/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { LiveConversationsAppQuery } from '@jira/customer-service__live-conversations/src/__generated__/LiveConversationsAppQuery.graphql';
import parameters from '@jira/customer-service__live-conversations/src/__generated__/LiveConversationsAppQuery$parameters';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type CustomerServiceLiveConversationsEntryPointComponent = EntryPointComponent<
	{
		LiveConversationsAppQuery: LiveConversationsAppQuery;
	},
	{},
	{},
	{} | null
>;

export const customerServiceLiveConversationsEntryPoint: EntryPoint<
	CustomerServiceLiveConversationsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CustomerServiceLiveConversationsEntryPointComponent>(
		/* webpackChunkName: "async-customer-service-live-conversations" */ './LiveConversationsSpaApp.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ tenantContext: { cloudId, atlassianAccountId } }: EntryPointRouteParams) => ({
		queries: {
			LiveConversationsAppQuery: {
				parameters,
				variables: {
					cloudId,
					atlassianAccountId: atlassianAccountId ?? '',
				},
			},
		},
	}),
});
